export default __webpack_public_path__ + "static/media/logoJavascript.eb93a639.png";